import snapdocsSubscriptions from './snapdocsSubscriptions.reducer';

const reducer = {
  snapdocsSubscriptions,
};

export default reducer;
